import AppointmentsCard from './AppointmentsCard'
import { Grid2 as Grid, Typography, useTheme } from '@mui/material'
import UserCards from './UserCards'
import TotalFundsCard from './TotalFundsCard'
import ClaimsCard from './ClaimsCard'
import InfoCard from './InfoCard'
import CustomerCard from './CustomerCard'
import useCustomStyles from '../../hooks/CustomStylesHook'

const styles = (theme: any) => ({
  cardsContentContainer: {
    flex: 1,
    overflowY: 'auto',
    paddingRight: theme.spacing(2),
  },
})

const Dashboard = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  return (
    <Grid container direction={'column'} spacing={1.5} height={'100%'}>
      <Grid size={{ xs: 12 }} position={'sticky'} top={0} zIndex={1}>
        <Typography variant='h4' fontWeight={'bold'}>
          Good Morning, Vinod!
        </Typography>
        <Typography variant='subtitle1' fontSize={'10px'} color='textSecondary'>
          Your Doing Good keep Up The Good Work
        </Typography>
      </Grid>
      <Grid
        container
        direction={'row'}
        spacing={1.5}
        className={classes?.cardsContentContainer}
      >
        <Grid size={{ xs: 12, sm: 12, lg: 6, md: 6, xl: 6 }}>
          <AppointmentsCard />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, lg: 6, md: 6, xl: 6 }}>
          <UserCards />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, lg: 6, md: 6, xl: 6 }}>
          <TotalFundsCard />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, lg: 6, md: 6, xl: 6 }}>
          <ClaimsCard />
        </Grid>

        <Grid size={{ xs: 12, sm: 12, lg: 4, md: 4, xl: 4 }}>
          <CustomerCard />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, lg: 4, md: 4, xl: 4 }}>
          <InfoCard name='Claims In Processing' requests={40} value={40000} />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, lg: 4, md: 4, xl: 4 }}>
          <InfoCard name='Claims Settled' requests={40} value={40000} />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Dashboard
